import { render } from "./MoreVersionItem.vue?vue&type=template&id=3d18b633&scoped=true"
import script from "./MoreVersionItem.vue?vue&type=script&lang=js"
export * from "./MoreVersionItem.vue?vue&type=script&lang=js"

import "./MoreVersionItem.vue?vue&type=style&index=0&id=3d18b633&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d18b633"]])

export default __exports__